<div class="suggestion-message" (click)="onSelectMessage(suggestedMessage())">
  <p class="suggestion-message__text">
    {{ suggestedMessage() }}
  </p>
</div>
